<template>
  <router-view />
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { find, get } from 'lodash-es';

import maps from './maps';

let ticking = false;

/**
 * @desc 최상위 vue
 * @vue-computed {Boolean} locale - 현재 언어
 * @vue-computed {Boolean} msg - i18n 객체
 * @vue-computed {Boolean} title - html title
 * @vue-computed {Boolean} description - html description
 */
export default {
  data() {
    return {
      externalLoaded: false
    };
  },
  computed: {
    ...mapState('view', {
      locale: 'locale'
    }),
    msg() {
      return this.$i18n.messages[this.$i18n.locale];
    },
    title() {
      return this.msg.title || '';
    },
    description() {
      return this.msg.description || '';
    }
  },
  mounted() {
    this.setLocale(process.env.VUE_APP_I18N_LOCALE || 'ko');
    this.addEvent();
  },
  metaInfo() {
    const resources =
      process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_RESOURCES
        : process.env.VUE_APP_RESOURCES_LOCAL;

    return {
      refreshOnceOnNavigation: true,
      title                  : this.title,
      htmlAttrs              : {
        lang: this.locale
      },
      meta: [
        { name   : 'viewport',
          content: 'width=device-width, initial-scale=1' },
        {
          name   : 'description',
          content: this.description
        }
      ],
      link: [
        process.env.VUE_APP_DEVICE === 'pc'
          ? {
            rel : 'stylesheet',
            href: `${resources}css/fonts.css`
          }
          : {},
        {
          rel : 'stylesheet',
          href: `${resources}css/common.css`
        },
        {
          rel : 'stylesheet',
          href: `${resources}css/layout.css`
        },
        {
          rel : 'stylesheet',
          href: `${resources}css/content.css`
        }
      ],
      script: [
        {
          src: `https://oapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${maps.info.id}`
        }
        /* {
          src     : `${resources}js/jquery-3.6.0.min.js`,
          callback: () => {
            this.externalLoaded = true;
          }
        } ,
        {
          skip: !this.externalLoaded,
          src : `${resources}js/common_ui.js`
        } */
      ]
    };
  },
  watch: {
    $route(value) {
      const pathLocale = this.$fo.getPathLocale(value.path) || 'ko';

      // i18n 변경
      this.$i18n.locale = pathLocale;

      // sessionStorage 변경
      sessionStorage.setItem('locale', pathLocale);

      // vuex view/locale 변경
      this.setLocale(pathLocale);

      // page 정보 저장
      this.setPathToPage(value);
    }
  },
  methods: {
    /**
     * path 기준으로 page 정보 저장 함수
     * @param params - 라우트 정보
     */
    setPathToPage({ path, hash }) {
      let arr = [];

      let menu, sub, tab;
      let _idx, _sidx, _tidx;

      menu = find(this.msg.header, (menu, idx) => {
        // console.log(idx, menu);

        _idx = idx;

        sub = find(menu.subs, (s, sidx) => {
          // console.log('  ㄴ', sidx, s, s.hash, s.tabs);

          _sidx = sidx;

          if (s.hash && hash !== '') {
            return s.path === path && s.hash === hash;
          } else {
            return s.path === path;
          }
        });

        if (hash && get(sub, 'tabs')) {
          tab = find(sub.tabs, (t, tidx) => {
            // console.log('    ㄴ', tidx, t);

            _tidx = tidx;

            return t.hash === hash;
          });
        }

        if (sub) {
          return true;
        }
      });

      if (menu) {
        arr.push({ idx: _idx,
          ...menu });

        if (sub) {
          arr.push({ idx: _sidx,
            ...sub });

          if (tab) {
            arr.push({ idx: _tidx,
              ...tab });
          }
        }
      }

      this.setPage(arr);
    },
    /**
     * 이벤트 정의 함수
     */
    addEvent() {
      document.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            //리페이팅 이전에 호출할 함수를 인자로 전달
            this.setScrollTop(
              window.pageYOffset || document.documentElement.scrollTop
            );

            ticking = false;
          });
          ticking = true;
        }
      });
    },
    ...mapMutations('view', {
      setScrollTop: 'SET_SCROLL_TOP',
      setLocale   : 'SET_LOCALE',
      setPage     : 'SET_PAGE'
    })
  }
};
</script>

<style lang="scss">
/* @import 'assets/css/reset.css'; */
@import 'assets/css/swiper.min.css';
</style>
